import { collection, query, where, getDocs } from 'firebase/firestore'

// A primka stores the supplier invoice number as `delivery_number` and the supplier name as `customer_name`.
export async function findPrimkeByInvoiceNumber (db, { warehouseIds, invoiceNumber, supplierName }) {
  const number = typeof invoiceNumber === 'string' ? invoiceNumber.trim() : ''
  const supplier = typeof supplierName === 'string' ? supplierName.trim() : ''
  if (!number || !supplier || !Array.isArray(warehouseIds) || !warehouseIds.length) return []

  const perWarehouse = await Promise.all(warehouseIds.map(async warehouseId => {
    const snapshot = await getDocs(query(
      collection(db, `warehouses/${warehouseId}/delivery_notes`),
      where('delivery_number', '==', number),
      where('customer_name', '==', supplier)
    ))
    return snapshot.docs.map(doc => ({ id: doc.id, warehouseId }))
  }))
  return perWarehouse.flat()
}
